import styled, { css } from 'styled-components';
import { BreakpointNames } from 'Theme/types/breakpoints.type';

export const List = styled.ul<{ $columns?: Partial<Record<BreakpointNames, number>> }>`
    ${({ theme, $columns }) => css`
        list-style: none;
        margin: 0;
        color: ${({ theme }) => theme.colors.secondary.tints[7].hex};
        font-family: ${theme.fonts.secondary};
        padding: 0.5rem;
        display: grid;
        row-gap: 0.5rem;

        ${$columns
            ? Object.keys($columns).map(
                  breakpoint => css`
                      @media ${theme.breakpoints[breakpoint].media} {
                          grid-template-columns: repeat(${$columns[breakpoint]}, 1fr);
                      }
                  `
              )
            : css`
                  @media ${theme.breakpoints.medium.media} {
                      grid-template-columns: repeat(2, 1fr);
                      row-gap: 1rem;
                  }

                  @media ${theme.breakpoints.large.media} {
                      grid-template-columns: repeat(3, 1fr);
                  }
              `}
    `}
`;

export const Item = styled.li`
    display: grid;
    grid-template-columns: 1fr 11fr;
    align-items: center;
    margin: 0 0 1rem;
`;

export const StyledIcon = styled.svg`
    width: 2rem;
    height: 2rem;
    color: ${({ theme }) => theme.colors.tertiary.hex};
`;

export const Text = styled.span`
    ${({ theme }) => css`
        padding-left: 0.75rem;
        font-size: 1.125rem;
        font-weight: 300;
        padding-right: 20%;

        @media ${theme.breakpoints.large.media} {
            padding-right: 30%;
        }
    `}
`;
